import { Button, Text } from '@change/ds-core-ui';
import { ChangeFlagIcon, MapIcon, TrendingIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { useLandingPage } from '#src/app/pages/search/shared/hooks';

import { useExploreButtons } from './hooks/useExploreButtons';

export const ExploreButtons: React.FC = () => {
	const {
		data: { isNearYouLoading },
		actions: { filterByNearYou, filterByTrending, filterByVictories },
	} = useExploreButtons();
	const {
		data: { showLandingPage },
	} = useLandingPage();

	return (
		<div className={showLandingPage ? 'mt-8 md:mt-16' : 'hidden'}>
			<div className="container">
				<Text variant="heading" as="h2" size="small" className="mt-0 mb-6 hidden md:block">
					<Translate value="corgi.search.explore.title" />
				</Text>
				<div className="grid grid-cols-3 gap-6">
					<ExploreButton
						icon={<MapIcon size="x-large" gradient />}
						text={
							<Text variant="body" as="span" size="large" className="text-center font-semibold">
								<Translate value="corgi.search.explore.near_you" />
							</Text>
						}
						onClick={filterByNearYou}
						disabled={isNearYouLoading}
						data-qa="explore-near-you-button"
					/>
					<ExploreButton
						icon={<TrendingIcon size="x-large" gradient />}
						text={
							<Text variant="body" as="span" size="large" className="text-center font-semibold">
								<Translate value="corgi.search.explore.trending" />
							</Text>
						}
						onClick={filterByTrending}
						data-qa="explore-trending-button"
					/>
					<ExploreButton
						icon={<ChangeFlagIcon size="x-large" gradient />}
						text={
							<Text variant="body" as="span" size="large" className="text-center font-semibold">
								<Translate value="corgi.search.explore.victories" />
							</Text>
						}
						onClick={filterByVictories}
						data-qa="explore-victories-button"
					/>
				</div>
			</div>
		</div>
	);
};

const ExploreButton: React.FC<{
	icon: React.ReactNode;
	text: React.ReactNode;
	onClick: () => void;
	disabled?: boolean;
}> = ({ icon, text, onClick, disabled }) => {
	return (
		<Button
			variant="secondary"
			className="rounded-large elevation-elevated active:elevation-elevated-selected hover:elevation-elevated-selected focus-visible:elevation-elevated-selected h-auto px-0 py-6 before:border-none"
			onClick={onClick}
			disabled={disabled}
		>
			<div className="flex flex-col items-center justify-center gap-2">
				{icon}
				{text}
			</div>
		</Button>
	);
};
